import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogisticsMainTruckCountService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LogisticsMainTruckCountCreateDto,
  LogisticsMainTruckCountDto,
  LogisticsMainTruckCountExcelDownloadDto,
  LogisticsMainTruckCountUpdateDto,
} from '../proxy/controlling/dtos/logistics-main-truck-count';
import { LOGISTICSMAINTRUCKCOUNT_CONFIG, LOGISTICSMAINTRUCKCOUNT_FIELDS } from './logistics-main-truck-count.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-logistics-main-truck-count',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LogisticsMainTruckCountService, ConfirmationService],
  templateUrl: './logistics-main-truck-count.html',
  styleUrl: './logistics-main-truck-count.scss',
})
export class LogisticsMainTruckCount extends BaseHierarchicalCrudComponent<
  LogisticsMainTruckCountDto,
  LogisticsMainTruckCountCreateDto,
  LogisticsMainTruckCountUpdateDto,
  LogisticsMainTruckCountExcelDownloadDto
> {
  service = inject(LogisticsMainTruckCountService);
  config = LOGISTICSMAINTRUCKCOUNT_CONFIG;
  fields = LOGISTICSMAINTRUCKCOUNT_FIELDS;

  protected prepareUpdateDto(data: any, selected: LogisticsMainTruckCountDto): LogisticsMainTruckCountUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LogisticsMainTruckCount';
  }
}
